import React from 'react';

import { InputAdornment, FormControl, OutlinedInput, InputLabel } from '@mui/material';
import KeywordToolTip from 'src/components/keyword-tooltip';
import { NumericFormatCustom } from './NumericFormatCustom';

const currencyFormatter = new Intl.NumberFormat('en-US', { currency: 'USD' });

// Format the placeholder if it's a valid number
const formatPlaceholder = (placeholder) => {
  if (typeof placeholder === 'number') placeholder = placeholder?.toString();
  if (!placeholder || typeof placeholder !== 'string') return placeholder;
  const parsed = parseFloat(placeholder?.replace(/,/g, ''));
  const isValid = !Number.isNaN(parsed);
  return isValid ? currencyFormatter.format(parsed) : placeholder;
};

export const CurrencyField = ({
  value,
  label,
  placeholder,
  handleFocus,
  onChange,
  stepSize,
  monthly = false,
  size,
  disabled,
  sx,
  compact = false,
  inputRef,
}) => (
  <FormControl fullWidth {...{ size, ...sx }}>
    <InputLabel id="type-label">
      <KeywordToolTip keyword={label} />
    </InputLabel>

    <OutlinedInput
      onFocus={handleFocus}
      label={<KeywordToolTip keyword={label} />}
      placeholder={formatPlaceholder(placeholder) ?? label}
      value={value ?? ''}
      onChange={onChange}
      startAdornment={<InputAdornment position="start">$</InputAdornment>}
      endAdornment={
        monthly && <InputAdornment position="end">/ {compact ? 'mo' : 'month'}</InputAdornment>
      }
      inputComponent={NumericFormatCustom}
      inputRef={inputRef}
      inputProps={{
        step: stepSize?.toString(),
      }}
      disabled={disabled}
    />
  </FormControl>
);
